import { Button, Grid } from '@material-ui/core'
import { useContext, useEffect, useState } from 'react'
import { RootStateOrAny, useDispatch, useSelector } from 'react-redux'
import { updateProject } from '../../../actions/projectActions'
import {
  PROJECT_CURRENT_STEP,
  PROJECT_EXIT_REQUEST,
  PROJECT_UPDATE_RESET,
} from '../../../constants/projectConstants'
import { Context } from '../../../providers/ProjectContextProvider'
import CheckboxInput from '../../Form/CheckboxInput'
import FormContainer from '../../Form/FormContainer'
import Loader from '../../Loader/Loader'
import Message from '../../Message/Message'

const AddOnServices = () => {
  const dispatch = useDispatch()

  const { project } = useSelector(
    (state: RootStateOrAny) => state.projectDetails
  )
  const { userInfo } = useSelector((state: RootStateOrAny) => state.userLogin)

  const { setShowNotifyUser } = useContext(Context)

  const [saveAndExit, setSaveAndExit] = useState(false)
  const [onsiteDebugging, setOnsiteDebugging] = useState(
    project.addOnServices.onsiteDebugging ? true : false
  )
  const [correlationGRR, setCorrelationGRR] = useState(
    project.addOnServices.correlationGRR ? true : false
  )
  const [fixtureDesign, setFixtureDesign] = useState(
    project.addOnServices.fixtureDesign ? true : false
  )
  const [premiumSupport, setPremiumSupport] = useState(
    project.addOnServices.premiumSupport ? true : false
  )
  const [classroomOrVirtualSupport, setClassroomOrVirtualSupport] = useState(
    project.addOnServices.classroomOrVirtualSupport ? true : false
  )
  const [customOnsiteTraining, setCustomOnsiteTraining] = useState(
    project.addOnServices.customOnsiteTraining ? true : false
  )
  const [detailsAreSet, setDetailsAreSet] = useState(false)
  const [stayOnPage, setStayOnPage] = useState(false)

  const {
    loading: loadingUpdate,
    error: errorUpdate,
    success: successProjectUpdate,
  } = useSelector((state: RootStateOrAny) => state.projectUpdate)

  useEffect(() => {
    if (successProjectUpdate) {
      dispatch({ type: PROJECT_UPDATE_RESET })

      if (stayOnPage) {
        setStayOnPage(false)
      } else {
        if (saveAndExit) {
          dispatch({ type: PROJECT_EXIT_REQUEST })
        } else {
          dispatch({
            type: PROJECT_CURRENT_STEP,
            payload: 9,
          })
        }
      }
    }

    if (project.addOnServices && !detailsAreSet) {
      if (Object.keys(project.deliveryDetails).length !== 0) {
        setDetailsAreSet(true)

        setCorrelationGRR(project.addOnServices.correlationGRR)
        setPremiumSupport(project.addOnServices.premiumSupport)
        setClassroomOrVirtualSupport(
          project.addOnServices.classroomOrVirtualSupport
        )
        setCustomOnsiteTraining(project.addOnServices.customOnsiteTraining)
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    dispatch,
    detailsAreSet,
    setCorrelationGRR,
    setCustomOnsiteTraining,
    setPremiumSupport,
    setClassroomOrVirtualSupport,
    successProjectUpdate,
    setDetailsAreSet,
    project,
    saveAndExit,
  ])

  const nextHandler = () => {
    let projectClone = JSON.parse(JSON.stringify(project)) // deep cloning

    projectClone.addOnServices = {
      onsiteDebugging,
      correlationGRR,
      fixtureDesign,
      premiumSupport,
      classroomOrVirtualSupport,
      customOnsiteTraining,
    }

    dispatch(updateProject(projectClone))
  }

  const handleSaveAndExit = () => {
    if (userInfo.isAdmin) {
      setStayOnPage(true)
      setShowNotifyUser(true)
      nextHandler()
    } else {
      setSaveAndExit(true)
      nextHandler()
    }
  }

  return (
    <div className="delivery-details">
      <FormContainer>
        <div className="flex space-between">
          <h4 className="m-b-30">
            Optional services{' '}
            {userInfo.isAdmin && project.userName && `for ${project.userName}`}
          </h4>
        </div>

        <Grid container spacing={4}>
          {project.type === 'programming' && (
            <>
              <Grid item xs={10} className="p-b-0">
                <CheckboxInput
                  name="Onsite debugging"
                  value={onsiteDebugging}
                  setValue={setOnsiteDebugging}
                  label={
                    <>
                      <div className="strong fs16 m-t-10">Onsite debugging</div>
                      <p className="m-b-0">
                        We come to your facility to setup and verify the CMM
                        measurement program. This may include modifying the
                        program based on the actual fixturing scenario or
                        measurement data, establishing the part location so
                        operators can run the program without manually driving
                        the CMM, and providing training for operators to
                        successfully measure parts.
                      </p>
                    </>
                  }
                />
              </Grid>

              <Grid item xs={2} className="p-b-0 flex flex-end">
                <div className="m-t-10">TBD</div>
              </Grid>
            </>
          )}

          <Grid item xs={10} className="p-b-0 p-t-0">
            <CheckboxInput
              name="Correlation GR+R"
              value={correlationGRR}
              setValue={setCorrelationGRR}
              label={
                <>
                  <div className="strong fs16 m-t-10">Correlation GR+R</div>
                  <p className="m-b-0">
                    If you have data you need the CMM data to correlate to, we
                    will work with you to align the measurement strategies so
                    they are both accurate and provide consistent results. We
                    can also perform Gage Repeatability and Reproducibility
                    (GR&R) studies to validate the entire measurement system.
                  </p>
                </>
              }
            />
          </Grid>
          <Grid item xs={2} className="p-b-0 p-t-0 flex flex-end">
            <div className="m-t-10">TBD</div>
          </Grid>

          {project.type === 'programming' && (
            <>
              <Grid item xs={10} className="p-b-0 p-t-0">
                <CheckboxInput
                  name="Fixture design"
                  value={fixtureDesign}
                  setValue={setFixtureDesign}
                  label={
                    <>
                      <div className="strong fs16 m-t-10">Fixture design</div>
                      <p className="m-b-0">
                        Hexagon will evaluate your prints to determine the best
                        way to fixture your part to replicate the datum
                        structures. Based on your requirements we will source
                        the creation of your custom holding fixture.
                      </p>
                    </>
                  }
                />
              </Grid>

              <Grid item xs={2} className="p-b-0 p-t-0 flex flex-end">
                <div className="m-t-10">TBD</div>
              </Grid>
            </>
          )}

          <Grid item xs={10} className="p-b-0 p-t-0">
            <CheckboxInput
              name="Premium support"
              value={premiumSupport}
              setValue={setPremiumSupport}
              label={
                <>
                  <div className="strong fs16 m-t-10">Premium support</div>
                  <p className="m-b-0">
                    Part of the MyCare package. Receive a block of virtual
                    support hours with a Hexagon Application Engineer to help
                    you overcome small hurdles. Please note that these hours
                    cannot be used for onsite support or training.
                  </p>
                </>
              }
            />
          </Grid>

          <Grid item xs={2} className="p-b-0 p-t-0 flex flex-end">
            <div className="m-t-10">TBD</div>
          </Grid>

          <Grid item xs={10} className="p-b-0 p-t-0">
            <CheckboxInput
              name="Classroom or virtual training"
              value={classroomOrVirtualSupport}
              setValue={setClassroomOrVirtualSupport}
              label={
                <>
                  <div className="strong fs16 m-t-10">
                    Classroom or virtual training
                  </div>
                  <p className="m-b-0">
                    Receive best-in-class training from a Hexagon AE at your
                    closest solution center or virtually. Classes include PCDMIS
                    Level 1-3, portable or stationary. Please note that training
                    may also incur travel expenses based on your location to the
                    nearest solution center.
                  </p>
                </>
              }
            />
          </Grid>

          <Grid item xs={2} className="p-b-0 p-t-0 flex flex-end">
            <div className="m-t-10">TBD</div>
          </Grid>

          <Grid item xs={10} className="p-b-0 p-t-0">
            <CheckboxInput
              name="Custom onsite training"
              value={customOnsiteTraining}
              setValue={setCustomOnsiteTraining}
              label={
                <>
                  <div className="strong fs16 m-t-10">
                    Custom onsite training
                  </div>
                  <p className="m-b-0">
                    Receive best-in-class training from a Hexagon AE at your
                    facility. Classes include PCDMIS Level 1-3, portable or
                    stationary. Please note that onsite training may also incur
                    travel expenses based on your location to the nearest
                    solution center.
                  </p>
                </>
              }
            />
          </Grid>

          <Grid item xs={2} className="p-b-0 p-t-0 flex flex-end">
            <div className="m-t-10">TBD</div>
          </Grid>
        </Grid>

        <div className="actions flex space-between m-t-40">
          <Button
            variant="contained"
            color="primary"
            className={loadingUpdate ? 'loading' : ''}
            disabled={loadingUpdate}
            onClick={handleSaveAndExit}
          >
            Save and exit
          </Button>
          <div className="flex">
            <Button
              variant="outlined"
              color="primary"
              onClick={() =>
                dispatch({
                  type: PROJECT_CURRENT_STEP,
                  payload: 7,
                })
              }
              className={`m-r-24 ${loadingUpdate ? 'loading' : ''}`}
              disabled={loadingUpdate}
            >
              Back
            </Button>
            <Button
              variant="contained"
              color="primary"
              onClick={nextHandler}
              className={loadingUpdate ? 'loading' : ''}
              disabled={loadingUpdate}
            >
              {loadingUpdate ? <Loader /> : 'Next'}
            </Button>
          </div>
        </div>
        {errorUpdate && <Message variant="error">{errorUpdate}</Message>}
      </FormContainer>
    </div>
  )
}

export default AddOnServices
